import { getStoreBuilder } from 'vuex-typex'
import { CommentState } from './state'
import { RootState } from '..'
import { IComment, Comment } from '@/model/comment'
import { IUser } from '@/model/user'
import fetchComments from './actions/fetch-comments'
import likeComment from './actions/like-comment'
import unlikeComment from './actions/unlike-comment'
import setMeta from './actions/set-meta'
import { IStatement } from '@/model/statement';

const initialState: CommentState = {
  comment: new Comment(),
  commentStatus: 0,
}

const storeBuilder = getStoreBuilder<RootState>()
const moduleBuilder = storeBuilder.module<CommentState>('comment', initialState)
const stateReader = moduleBuilder.state()

const commentStore = {
  get state () { return stateReader() },
  commitSetComment: moduleBuilder.commit((state: CommentState, payload: { comment: IComment }) => state.comment = payload.comment, 'setComment'),
  commitSetNumLikes: moduleBuilder.commit((state: CommentState, payload: { comment: IComment, numLikes: number }) => {
    if (payload.comment.meta) payload.comment.meta.numLikes = payload.numLikes
  }, 'setNumLikes'),
  commitSetIsLiked: moduleBuilder.commit((state: CommentState, payload: { comment: IComment, isLiked: boolean }) => {
    if (payload.comment.meta) payload.comment.meta.isLiked = payload.isLiked
  }, 'setIsLiked'),
  commitSetCreator: moduleBuilder.commit((state: CommentState, payload: { comment: IComment, creator: IUser }) => {
    if (payload.comment.meta) payload.comment.meta.creator = payload.creator
  }, 'setCreator'),
  commitSetComments: moduleBuilder.commit((state: CommentState, payload: { comment: IComment, comments: IComment[] }) => {
    if (payload.comment.meta) payload.comment.meta.comments = payload.comments
  }, 'setComments'),
  commitSetStatements: moduleBuilder.commit((state: CommentState, payload: { comment: IComment, statements: IStatement[] }) => {
    if (payload.comment.meta) payload.comment.meta.statements = payload.statements
  }, 'setStatements'),
  commitResetCommentForm: moduleBuilder.commit((state: CommentState, payload: { comment: IComment }) => {
    if (payload.comment.meta) {
      payload.comment.meta.newTitle = ''
      payload.comment.meta.newBody = ''
    }
  }, 'resetCommentForm'),
  commitSetIsAllJybed: moduleBuilder.commit((state: CommentState, payload: { comment: IComment, isAllJybed: boolean }) => {
    if (payload.comment.meta) payload.comment.meta.isAllJybed = payload.isAllJybed
  }, 'setIsAllJybed'),
  dispatchFetchComments: moduleBuilder.dispatch(fetchComments),
  dispatchLikeComment: moduleBuilder.dispatch(likeComment),
  dispatchUnlikeComment: moduleBuilder.dispatch(unlikeComment),
  dispatchSetMeta: moduleBuilder.dispatch(setMeta),
}

export default commentStore